export default "__VITE_PUBLIC_ASSET__613f4acc__"